import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TutorialState } from '../types';
import { stepsList } from '../pages/mainStage/consts';
import { loadTutorialState, saveTutorialState } from './storage';

const initialState: TutorialState = {
  ready: false,
  step: 1,
  finished: false,
  background: false,
};

export const tutorialSlice = createSlice({
  name: 'tutorial',
  initialState,
  reducers: {
    init(state) {
      const saved = loadTutorialState();
      if (saved) {
        state.step = saved.step;
        state.finished = saved.finished;
      }
      state.ready = true;
    },

    nextStep(state) {
      const next = state.step + 1;

      if (next > stepsList.length) {
        state.finished = true;
      } else {
        state.step = next;
      }

      saveTutorialState({
        step: state.step,
        finished: state.finished,
      });
    },

    setStep(state, action: PayloadAction<number>) {
      state.step = action.payload;
      saveTutorialState({
        step: state.step,
        finished: state.finished,
      });
    },

    skipTutorial(state) {
      state.finished = true;
      saveTutorialState({
        step: state.step,
        finished: true,
      });
    },

    setBackground(state, action: PayloadAction<boolean>) {
      state.background = action.payload;
    },
  },
});

export const { init, nextStep, setStep, skipTutorial, setBackground } =
  tutorialSlice.actions;

export default tutorialSlice.reducer;
